/**
 * Enable form validation
 * 
 * @export
 * @class Validation
 */
// @ts-ignore
import * as hyperform from 'hyperform/dist/hyperform.cjs.js';

export class Validation {

    constructor() {

        // Change message
        hyperform.addTranslation('en', {
            ValueMissing: 'Required',
        });

        hyperform(window);
    }
}
